import { Container, Box, Button, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { t } from "i18next";
import { selectedMenuState, selectedButtonState } from "../../recoil";
import { formatDate } from "../../utils/utils";
import { getAIServerList } from "../../services/serverRuleService.js";
import ServerManageTable from "./ServerManageTable.js";
import CustomButton from "../customComponent/CustomButton";

export default function ServerManageMain() {
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);
  const [serverList, setServerList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [adminMode, setAdminMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedMenu(t("ServerManage"));
    setSelectedButton(t("ServerManage"));
    fetchData();
  }, []);

  useEffect(() => {
    if (refresh) {
      fetchData();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    let inputBuffer = "";

    const handleKeyDown = (e: KeyboardEvent) => {
      inputBuffer += e.key;

      if (inputBuffer.length > 8) {
        inputBuffer = inputBuffer.slice(-8);
      }

      if (inputBuffer === "hims1111") {
        setAdminMode(true);
        inputBuffer = "";
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getAIServerList();
      const extractedData = response.map((list: any) => ({
        ...list,
        create_at: formatDate(list.create_at),
      }));
      setCount(extractedData.length);
      setServerList(extractedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">서버 관리</h1>
        </div>
      </div>
      <Container sx={{ display: "flex", flexDirection: "column" }} maxWidth={false}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "42px",
          }}
        >
          {adminMode && (
            <CustomButton
              id="new-train-btn"
              text={t("CreateServer")}
              variant="outlined"
              onClick={() => {
                navigate("/server-manage/create");
              }}
            />
          )}
        </Box>
        <ServerManageTable
          serverList={serverList}
          setRefresh={setRefresh}
          loading={loading}
          setCount={setCount}
          total={count}
          currentPage={currentPage}
          setPage={setCurrentPage}
        />
      </Container>
    </>
  );
}
